import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import styles from './MMRMessageContent.css';

export default ({ activeFundMessages }) => (
    <div id="mmr-messages">
        {activeFundMessages &&
            activeFundMessages.map((ele) => (
                <div key={ele.messageType} className="mmr-content">
                    {ele.messageType === 'NCR' && (
                        <div className="mmr-ncr-message mmr-message">
                            {ReactHtmlParser(ele.message)}
                        </div>
                    )}
                    {ele.messageType === 'FEE' && (
                        <div className="mmr-fee-message mmr-message">
                            {ReactHtmlParser(ele.message)}
                        </div>
                    )}
                    {ele.messageType === 'GATE' && (
                        <div className="mmr-gate-message mmr-message.">
                            {ReactHtmlParser(ele.message)}
                        </div>
                    )}
                </div>
            ))}
        <style jsx>{styles}</style>
    </div>
);
